import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import WalletETHModal from "../walletsManagment/WalletETHModal";
import Header from "./Header";
import "./Header.css";
import {
  activateInjectedProvider,
  AppContext,
  connectors,
} from "../walletsManagment/connectors";
import { getAuth } from "firebase/auth";
import { CONNECTORS } from "../../utils/constants/config";

const HeaderEth = () => {
  const [isWalletModalOpen, setWalletModalOpen] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const { setEithAuthToken, eithAuthToken, setEithProvider, values } =
    useContext(AppContext);
  const { activate, active, account, error } = useWeb3React();
  const navigate = useNavigate();

  const goToInventary = () => {
    navigate("/monsterzone/inventory");
  };

  const goToMap = () => {
    navigate("/monsterzone");
  };

  const openModal = () => {
    setWalletModalOpen(true);
  };

  const closeModal = () => {
    setWalletModalOpen(false);
  };

  useEffect(() => {
    let tokenSubscriber = null;
    if (active) {
      tokenSubscriber = getAuth().onIdTokenChanged(function (user) {
        if (user) {
          setEithAuthToken(user?.accessToken);
        }
      });

      // subscribeCalls()
    } else {
      const provider = localStorage.getItem("e_provider");

      let connecetor = null;
      if (provider == CONNECTORS.INJECTED) {
        connecetor = connectors.injected();
      } else {
        connecetor = connectors.walletConnect(values);
      }
      if (provider) {
        setIsConnecting(true);
        setTimeout(() => {
          setIsConnecting(false);
          activateInjectedProvider("MetaMask");
          activate(connecetor, (err) => {
            setEithProvider("");
          });
        }, 1000);
      }
    }
    return () => {
      tokenSubscriber?.();
    };
  }, [active]);

  return (
    <React.Fragment>
      <Header
        openWalletModal={openModal}
        goToInventary={goToInventary}
        account={eithAuthToken ? account : null}
        showInvetory={active && eithAuthToken}
        goToMap={goToMap}
        isConnecting={isConnecting}
      />
      {isWalletModalOpen && (
        <WalletETHModal
          modalVisibility={isWalletModalOpen}
          closeModal={closeModal}
        />
      )}
    </React.Fragment>
  );
};

export default HeaderEth;
